export const SEARCH_RESULTS_EVENT_CATEGORY = 'search_results' as const;